import React from "react";

/**
 * PermissionGrid
 * - features: string[] (claves de funcionalidades que se persisten en Firestore)
 * - columns: { key: string; label: string }[]
 * - values: Record<featureKey, Record<columnKey, boolean>>
 * - onToggle: (featureKey, columnKey, value) => void
 * - featureLabels: Record<featureKey, string> opcional. Si esta presente, se
 *   muestra el label en lugar de la key. Permite renombrar la etiqueta visible
 *   (ej: "Pagar Expensas" -> "Pagar Gastos Comunes") sin migrar permisos.
 */
export default function PermissionGrid({ features, columns, values, onToggle, featureLabels }) {
  return (
    <div style={styles.wrapper}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={{ ...styles.th, textAlign: "left" }}>Funcionalidad</th>
            {columns.map((c) => (
              <th key={c.key} style={styles.th}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {features.map((feat) => (
            <tr key={feat} style={styles.row}>
              <td style={styles.tdLeft}>{featureLabels?.[feat] || feat}</td>
              {columns.map((c) => (
                <td key={c.key} style={styles.tdCenter}>
                  <input
                    type="checkbox"
                    checked={!!values?.[feat]?.[c.key]}
                    onChange={(e) => onToggle(feat, c.key, e.target.checked)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  wrapper: {
    width: "100%",
    overflowX: "auto",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    backgroundColor: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
  },
  th: {
    background: "#f9fafb",
    fontSize: 12,
    letterSpacing: 0.3,
    textTransform: "uppercase",
    color: "#6b7280",
    padding: "12px 16px",
    borderBottom: "1px solid #e5e7eb",
    whiteSpace: "nowrap",
  },
  row: {
    borderBottom: "1px solid #f1f5f9",
  },
  tdLeft: {
    padding: "12px 16px",
    fontSize: 14,
    color: "#111827",
    borderBottom: "1px solid #f1f5f9",
    whiteSpace: "nowrap",
  },
  tdCenter: {
    padding: "12px 16px",
    textAlign: "center",
    borderBottom: "1px solid #f1f5f9",
  },
};
